export class UnsupportedProvinceError extends Error {
  constructor() {
    super('Unsupported province');
  }
}
